import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from "@/shared/ui/card";
import BaseLayout from '@/shared/components/accounts/AccountBase';
import { PasswordResetWithTokenForm } from '@/features/reset-password';

const ResetPasswordConfirm = () => {
  const { uidb64, token } = useParams<{ uidb64: string; token: string }>();
  const navigate = useNavigate();

  // If no token or uidb64, show error
  if (!uidb64 || !token) {
    return (
      <BaseLayout>
        <Card className="w-full max-w-md mx-auto">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl text-center">Invalid Reset Link</CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-800">
                This password reset link is invalid. Please request a new one.
              </p>
            </div>
          </CardContent>
        </Card>
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <Card className="w-full max-w-md mx-auto">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center">Reset Your Password</CardTitle>
          <p className="text-sm text-gray-600 text-center">
            Enter a new password for your account
          </p>
        </CardHeader>
        <CardContent>
          <PasswordResetWithTokenForm
            uidb64={uidb64}
            token={token}
            onSuccess={() => {
              // Redirect to login after 2 seconds
              setTimeout(() => {
                navigate('/login');
              }, 2000);
            }}
          />
        </CardContent>
      </Card>
    </BaseLayout>
  );
};

export default ResetPasswordConfirm; 